import AttributesCoVPercentageField from './AttributesCoVPercentageField'

export default AttributesCoVPercentageField
